import { COMPARATOR_TYPES, Filter } from '~/searchApi';

export const ageRangeFilter = (ageRange: string): Filter[] => {
  const today = new Date();
  const ageRangeMatch = ageRange.match(/^(\d+):(\d+)(\+?)$/);
  if (!ageRangeMatch) {
    return [];
  }

  const minAge = parseInt(ageRangeMatch[1], 10);
  const maxAge = parseInt(ageRangeMatch[2], 10);
  const hasPlus = ageRangeMatch[3] === '+';

  const minDate = new Date(
    today.getFullYear() - maxAge,
    today.getMonth(),
    today.getDate(),
  );
  const maxDate = new Date(
    today.getFullYear() - minAge,
    today.getMonth(),
    today.getDate(),
  );

  if (hasPlus) {
    const minDate = new Date(
      today.getFullYear() - minAge,
      today.getMonth(),
      today.getDate(),
    );

    return [
      {
        name: 'date_of_birth',
        comparator: COMPARATOR_TYPES.LT,
        value: minDate.toISOString(),
      },
    ];
  }

  return [
    {
      name: 'date_of_birth',
      comparator: COMPARATOR_TYPES.GT,
      value: minDate.toISOString(),
    },
    {
      name: 'date_of_birth',
      comparator: COMPARATOR_TYPES.LT,
      value: maxDate.toISOString(),
    },
  ];
};
